import {boot} from 'quasar/wrappers';
import trackContentDirective from 'src/directive/TrackContent';

export default boot(({app}) => {
  app.directive('track-content', trackContentDirective)
});
